export const allSelector = (state) => state?.groupReducer?.group;
